import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { type FeedFlowItem } from '@src/services/interface';
import TopicText from '@src/mobile/article/layout/content/components/topicText';
import Quote from '@src/mobile/article/layout/content/components/quote';
import PicTextVideo from '@src/mobile/article/layout/content/components/picTextVideo';
import ForwardText from '@src/mobile/components/forwardText';
import Tweet from '@src/mobile/components/tweet';

type TranslateContentProps = {
    content: FeedFlowItem | null;
};

const TranslateContent = ({ content }: TranslateContentProps) => {
    const topicData = {
        text: content?.topicTitle,
        topicId: content?.topicId,
    };
    const summary = content?.summary;
    const forwardTextData = {
        isFeed: false,
        text: (content?.sourceInfo && JSON.parse(content?.sourceInfo)?.title) || '',
    };
    const picTextVideo = {
        richContent: content?.richContent,
        richResource: content?.richResource,
    };
    const tweetData = {
        isFeed: false,
        forwardStatus: content?.forwardStatus,
        forwardItem: content?.forwardItem?.forwardList?.[0],
        post: content?.post,
    };

    return (
        <>
            <TopicText content={topicData} />
            <Quote content={summary} />
            <PicTextVideo content={picTextVideo} />
            <ForwardText content={forwardTextData} />
            <Tweet content={tweetData} />
        </>
    );
};

export default errorBoundary(TranslateContent);
